/**
 * Legend component entry file8
 */


    require('./legend');

    require('./legend/ScrollableLegendModel');
    require('./legend/ScrollableLegendView');
    require('./legend/scrollableLegendAction');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/legendScroll.js
// module id = P7ry
// module chunks = 5